<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 22"><path d="M19.5 0h-14a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5m-14 2h14a3 3 0 0 1 3 3v2h-20V5a3 3 0 0 1 3-3m14 18h-14a3 3 0 0 1-3-3V9h20v8a3 3 0 0 1-3 3" class="tw-fill-namaGray dark:tw-fill-white"/></svg>
</template>
